"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var core_1 = require("@dynamynd/core");

var routes_1 = require("@dynamynd/routes");

var react_1 = __importDefault(require("react"));

var RecoverWrongModule = react_1.default.memo(function (_a) {
  var navigateTo = _a.navigateTo;
  return react_1.default.createElement(components_lib_1.ColumnCentered, null, react_1.default.createElement(components_lib_1.ParagraphWithMargin, null, "Something is wrong."), react_1.default.createElement(components_lib_1.Button, {
    type: components_lib_1.ButtonTypeEnum.primary,
    text: "Refresh",
    onPress: function onPress() {
      return navigateTo(routes_1.RoutesKeysEnum.dashboard);
    },
    uppercase: true
  }));
});
exports.default = core_1.withNavigateTo(RecoverWrongModule);